import SelectApplicationLanguage from '.';
const SelectApplicationLanguageRoutes = [
    {
        name: '/select-application-language',
        deepLink: '/select-application-language',
        component: SelectApplicationLanguage,
    },
];
export default SelectApplicationLanguageRoutes;
